import request from '@/utils/request'

export function picList (data) {
    return request({
        url: 'pic/list',
        method: 'GET',
        params: data
    })
}

export function picDetail (data) {
    return request({
        url: 'pic/detail',
        method: 'GET',
        params: data
    })
}